<template>
  <div class="search-page">
    <img :src="banner.imgUrl" class="cov-img page-banner" alt="">
    <div class="center">
      <pane-title title="搜索结果" sub-title="Search Result" />
      <div class="res-msg">
        搜索到结果{{total}}条：
      </div>

      <div class="list">
        <div class="item" v-for="item in list" :key="item.id">
          <p class="tit wrap-txt">
            <a @click="jumpDetail(item)" target="_blank">{{item.title}}</a>
          </p>
          <p class="txt txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">
            <span class="txt-p" v-html="item.description"></span>
            <a
                class="link-tag-small"
                target="_blank"
                @click="jumpDetail(item)"
                v-if="item.jumpUrl"
            >
              &lsaquo;&nbsp;{{lang === 'zh' ? '详情' : 'More' }}&nbsp;&rsaquo;
            </a>
          </p>
          <p class="time-box">{{ item.date }}</p>
        </div>
      </div>

      <div class="pagination">
        <div
          v-for="i in pageLen"
          :class="{
            'page-slide': true,
            'active-page': current === i
          }"
          @click="changePage(i)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchPage",
  data() {
    return {
      keywords: '',
      total: 0,
      pageSize: 10,
      current: 1,
      tempList: [],
      banner: {
        imgUrl: ''
      }
    }
  },
  computed: {
    lang() {
      return this.$store.state.plang;
    },
    pageLen() {
      return Math.ceil(this.total / this.pageSize) || 0;
    },
    list() {
      const kw = this.keywords;
      if(!kw) return [];
      return this.tempList.map(item => {
        let str = item.description;
        let i = str.indexOf(kw);
        while(i >= 0) {
          str = str.replace(kw, 'zwlKey');
          i = str.indexOf(kw);
        }
        str = str.replace(/zwlKey/g, `<span class="key-word">${kw}</span>`);

        const time = item.publishTime;
        let date = '';
        if(time) {
          const yy = time.substr(0, 4);
          const mm = time.substr(4, 2);
          const dd = time.substr(6, 2);
          date = `${yy}-${mm}-${dd}`;
        }

        return {...item, description: str, date};
      })
    }
  },
  methods: {
    getBanner() {
      this.$http.getOnlyContent({
        itemType: '0',
        platform: 'pc',
        language: 'china'
      }).then(res => {
        this.banner = res.imageMaps['00'][0];
      });
    },
    getData() {
      this.$http.searchContent({
        pageNo: this.current,
        pageSize: this.pageSize,
        keyWords: this.keywords,
        platform: 'pc',
        language: this.lang === 'zh' ? 'china' : 'english'
      }).then(res => {
        this.total = res.total;
        this.tempList = res.records;
      })
    },
    changePage(page) {
      this.current = page;
      this.getData();
    },
    jumpDetail(item) {
      const link = item.jumpUrl;
      if(link === 'local') {
        window.open('/pc/detail/' + item.id + '?lang=' + this.lang);
      } else if(link) {
        window.open(link)
      }
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler(v) {
        this.keywords = v.query.keywords;
      }
    },
    keywords: {
      immediate: true,
      handler() {
        this.getData();
      }
    },
    lang: {
      handler(v) {
        this.getData();
      }
    }
  },
  created() {
    this.getBanner();
  }
}
</script>

<style lang="less">
.pc-home {
  .search-page {
    padding-bottom: 120px;
    .key-word {
      color: #037698;
    }
    .res-msg {
      font-weight: bold;
      color: #2e2e2e;
      border-bottom: 3px solid #037698;
      padding: 0 0 16px 50px;
      margin-bottom: 42px;
    }
    .list {
      .item {
        padding-bottom: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #a0a0a0;
      }
      .tit {
        margin-bottom: 15px;
        a {
          color: #037698;
          font-weight: bolder;
          text-decoration: none;
          cursor: pointer;
        }
      }
      .txt {
        display: inline-block;
        line-height: 29px;
        text-indent: 2em;
        text-overflow:ellipsis;
        margin-bottom: 15px;
      }
      .time-box {
        text-align: right;
        color: #037698;
        font-size: 14px;
      }
    }
    .pagination {
      text-align: center;
      .page-slide {
        display: inline-block;
        width: 14px;
        height: 14px;
        border: 1px solid #037698;
        border-radius: 50%;
        margin: 0 5px;
        cursor: pointer;
      }
      .active-page {
        background: #037698;
      }
    }
  }
}
</style>
